



































































































































































      import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { round } from 'lodash';
import Debug from 'debug';
import dayjs from 'dayjs';
import i18n from '@/plugins/i18n';
import router from '@/router';
import { TranslateResult } from 'vue-i18n';
import { resolve, lazyInject } from '@/app/container';
import { createEvent } from '@/app/event-stream';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
//import { BeforeNavigateFromQuizEventName } from '@/app/quiz/events/quiz-events';
import { removeElement, scrollToTop } from '@/app/shared/utils/content-utils';
//import { QuestionAnsweredEvent, QuestionAnsweredEventName } from '@/app/question/events/question-events';
import { QuestionAnsweredPayload,
         QuestionStateChangedPayload } from '@/app/question/components/question-component2.vue'
//import quizSessionStoreModule from '@/app/quiz/state/quiz-session-state';
import QuizIntroComponent from '@/app/quiz/components/quiz-intro-component.vue';
import QuizStatusBarComponentNew from '@/app/quiz/components/quiz-statusbar-component2.vue';
import QuizQuestionsComponentNew from '@/app/quiz/components/quiz-questions-component-new.vue';
import QuizResultComponentNew from '@/app/quiz/components/quiz-result-component-new.vue';
import UiPopupComponent from '@/app/shared/components/ui/ui-popup-component.vue';
import { ExamStateMachine, ExamStateMachineData } from '@/app/exam-player/domain'
import { PracticeStateMachine, PracticeStateMachineData } from '@/app/practice-player/domain'
import { QuizPlayerStateMachine, QuizPlayerStateMachineData } from '@/app/quiz-player/domain'
import { EXAM_SCORE_DISPLAY_PRECISION } from '@/app/exam/ui/exam-score-display'
import { PRACTICE_SCORE_DISPLAY_PRECISION } from '@/app/practice/ui/practice-score-display'

const debug = Debug('quiz-component')

@Component({
  components: {
    QuizIntroComponent, QuizStatusBarComponentNew,
    QuizQuestionsComponentNew, QuizResultComponentNew,
    UiPopupComponent
  }
})
export default class QuizComponent extends Vue {
  // @Prop()
  // public quiz: Quiz;

  @Prop({ required: true })
  public quizId: string

  private EXAM_SCORE_DISPLAY_PRECISION = EXAM_SCORE_DISPLAY_PRECISION
  private PRACTICE_SCORE_DISPLAY_PRECISION = PRACTICE_SCORE_DISPLAY_PRECISION
  
  private showQuestionCountPopup: boolean = false;
  private showFinishMessagePopup: boolean = false;
  private showAbortMessagePopup: boolean = false;
  private isTimeExpiredPopupVisible: boolean = false;
  private selectedPracticeQuestionCount: number = 0;
  private finishMessage: TranslateResult = '';
  private abortMessage: TranslateResult = '';

  private examState: ExamStateMachineData = new ExamStateMachineData()
  private practiceState: PracticeStateMachineData = new PracticeStateMachineData()

  @lazyInject(QuizPlayerStateMachine)
  private quizPlayerStateMachine: QuizPlayerStateMachine

  private quizPlayerState = new QuizPlayerStateMachineData()

  private get description() {
    // we show the exam's description if we have
    if (this.quizPlayerState.hasExam && this.quizPlayerState.examDescription) {
      return this.quizPlayerState.examDescription
    }

    // if not, show the practice's
    if (this.quizPlayerState.hasPractice && this.quizPlayerState.practiceDescription) {
      return this.quizPlayerState.practiceDescription
    }

    return ''
  }
  
    private mounted(): void {
      //removeElement('h3'); // TODO: remove this

      this.quizPlayerStateMachine.initialize(this.quizPlayerState,
                                             this.practiceState,
                                             this.examState)
      this.quizPlayerStateMachine.onStartPracticeRequested = () => this.startPractice()
      this.quizPlayerStateMachine.onExamTimeExpired = () => this.showTimeExpiredPopup()
      this.quizPlayerStateMachine.onContinueError = () => this.showContinueError()
      this.quizPlayerStateMachine.start(this.quizId, 'default') // TODO: use global aspect id

      const currentRoute: Route = router.currentRoute;
      const continueInQuery: boolean = currentRoute.query.continue === '1';
      if (continueInQuery) {
        throw new Error('continue')
      }
    }

  private beforeDestroy() {
      debug('beforeDestroy')
      this.quizPlayerStateMachine.cancel()
    }

  private destroyed(): void {
    debug('destroyed')
    }

    private handleStartExamClicked() {
      this.quizPlayerStateMachine.startExam()
    }

    private handleStartPracticeClicked() {
      this.startPractice()
    }

    private startPractice() {
      this.selectedPracticeQuestionCount = this.quizPlayerState.practiceQuestionCount
      this.showQuestionCountPopup = true;
    }

    private handleContinue() {
      debug('handleContinue')
      this.continue()
    }

    private handleQuestionCountConfirmed() {
      this.showQuestionCountPopup = false;
      this.quizPlayerStateMachine.startPractice(this.selectedPracticeQuestionCount)
    }

    private handleNavigated(index: number) {
      this.quizPlayerStateMachine.executeChildAction(sm => sm.navigate(index))
    }

    private handlePrevNavigated() {
      this.quizPlayerStateMachine.executeChildAction(sm => sm.navigatePrevious())
    }

    private handleNextNavigated() {
      this.quizPlayerStateMachine.executeChildAction(sm => sm.navigateNext())
    }

    private handleBackToResult() {
      this.quizPlayerStateMachine.executeChildAction(sm => sm.finish())
    }

    private handleAnswerChanged2({ answer, evaluation }: QuestionAnsweredPayload): void {
      this.quizPlayerStateMachine.executeChildAction(sm => sm.changeAnswer(answer, evaluation))
    }

  private handleStateChanged(state: QuestionStateChangedPayload) {
      debug('handleStateChanged', state)
     this.quizPlayerStateMachine.executeChildAction(sm => sm.changeState(state))
    }

    private handleEvaluated() {
      this.quizPlayerStateMachine.executePracticeAction(sm => sm.evaluateQuestion())
    }

    private handleShowSolution() {
      this.quizPlayerStateMachine.executePracticeAction(sm => sm.showQuestionSolution())
    }

    private handleReset() {
      this.quizPlayerStateMachine.executeChildAction(sm => sm.resetQuestion())
    }

    private showContinueError() {
      // TODO: message
      alert('Could not continue started exam or practice session')
    }

    private showTimeExpiredPopup() {
      this.isTimeExpiredPopupVisible = true;
    }

    private handleTimeExpiredOkClicked() {
      this.isTimeExpiredPopupVisible = false;
    }

    private handleAbort(withConfirm: boolean) {
      debug('handleAbort', withConfirm)
      if (withConfirm) {
        const mode = this.quizPlayerState.sessionModeToContinue
        this.abortMessage = i18n.t(`quiz.abort_${mode}_question`);
        this.showAbortMessagePopup = true
      } else {
        this.showAbortMessagePopup = false
        this.abort()
      }
    }  

    private handleFinish(withConfirm: boolean) {
      
      if (withConfirm) {
        let mode
        let notAnsweredCount = 0
        if (this.quizPlayerState.isInPractice) {
          notAnsweredCount = this.practiceState.notAnsweredQuestionCount
          mode = 'practice'
        } else if (this.quizPlayerState.isInExam) {
          notAnsweredCount = this.examState.notAnsweredQuestionCount
          mode = 'exam'
        }
        let finishMessage: TranslateResult = '';
        if (notAnsweredCount > 0) {
          finishMessage = i18n.t(`quiz.abort_${mode}_question`);
          finishMessage += ' ';
          finishMessage += i18n.tc('quiz.not_answered_questions_warning', notAnsweredCount);
        } else {
          finishMessage = i18n.t(`quiz.finish_${mode}_question`);
        }

        this.finishMessage = finishMessage
        this.showFinishMessagePopup = true;
      } else {
        this.showFinishMessagePopup = false;
        this.finish();
      }
    }

  private handleTryAgain(quizMode: 'exam' | 'practice') {
      debug('tryAgain', quizMode)
      this.quizPlayerStateMachine.tryAgain(quizMode)
    }

    private t(key: string, params: any = {}): TranslateResult {
      return i18n.t(key, params);
    }

    private abort() {
      this.quizPlayerStateMachine.abortFoundSession()
    }

    private continue() {
      this.quizPlayerStateMachine.continueFoundSession()
    }
  
    private finish() {
      this.quizPlayerStateMachine.executeChildAction(sm => sm.finish())
    }
  }
